import React from 'react';
import {SecondaryButton} from '@softura/fluentuipackage'

const SecondaryButtoncontainer = (props:any) => {
    return  <SecondaryButton
    text={props.text}
    className={props.className}
    onClick={props.onClick}
    title={props.title}
    disabled={props.disabled}
  ></SecondaryButton>
}

export default SecondaryButtoncontainer